<template>
  <v-app>
    <v-app-bar app color="white" elevation="0">
      <img src="../assets/logo.png" class="mr-2" alt="VeriScan Logo" width="40" height="40">
      {{ $t('label.veriscan') }}
    </v-app-bar>

    <v-main>

      <v-alert :value="error" type="error" tile dense>{{ errorMessage }}</v-alert>

      <v-container class="fill-height" fluid>
        <v-spacer />
        <v-form @submit.prevent="login()" ref="form" lazy-validation>
          <v-card outlined width="500" :loading="loading">
            <v-card-title class="justify-center">
              <img src="../assets/logo.png" class="mb-8" alt="VeriScan Logo" width="70" height="70">
              <!-- <v-img
                class="mb-6"
                transition="scale-transition"
                src="../assets/logo.png"
                max-height="70"
                max-width="70"
              /> -->
            </v-card-title>

            <v-card-subtitle align="center" class="display-1">{{ $t('label.welcome') }}</v-card-subtitle>
            <v-card-text>
              <v-text-field v-model="username" autofocus :label="$t('label.email')" prepend-icon="person" type="text"
                :rules="[rules.required, rules.email]" validate-on-blur />
              <v-text-field v-model="password" :error="authError" :error-messages="authErrorMessage"
                :label="$t('label.password')" prepend-icon="lock" type="password" :rules="[rules.required]"
                validate-on-blur />
            </v-card-text>
            <v-card-actions>
              <!-- <v-btn
                  text
                  small
                  color="primary"
                  @click="register()"
                >{{ $t('view.login.button.register') }}</v-btn> -->

              <!-- language dropdown -->
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" text small v-bind="attrs" v-on="on">
                    English (US)
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in locales" :key="index" @click="changeLocale(item.locale)">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-spacer />
              <v-btn tile color="primary" type="submit" :disabled="loginDisabled">{{ $t('view.login.button.login')
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
        <v-spacer />
      </v-container>
      <!-- <v-footer app color="white" class="align-bottom justify-end">
        <p class="text-caption align-end justify-end">{{ getAppVersion }}</p>
      </v-footer> -->
      <p class="text-caption grey--text versionFooter mb-0 mr-2">{{ getAppVersion }}</p>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      loginDisabled: false,
      authError: false,
      authErrorMessage: "",
      error: false,
      errorMessage: "",
      username: "",
      password: "",
      locales: [
        { title: "English (US)", locale: "en" },
        { title: "中文", locale: "ch" }
      ],
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      }
    };
  },
  computed: {
    ...mapGetters(["getAppVersion"]),
  },
  methods: {
    ...mapActions(["authRequest", "loadWebConfig"]),
    changeLocale(newLocale) {
      this.$i18n.locale = newLocale;
    },
    login: function () {

      if (!this.$refs.form.validate()) {
        return false
      }

      this.authError = false
      this.authErrorMessage = ""
      this.error = false
      this.errorMessage = ""
      this.loading = true
      this.loginDisabled = true
      const { username, password } = this
      this.authRequest({ username, password })
        .then(() => {
          this.$router.push("/")
        })
        .catch(error => {
          if (401 == error.response.status) {
            this.authError = true
            this.authErrorMessage = "Incorrect username or password. Please try again."
          } else {
            this.errorMessage = "Sorry, there has been a problem and support has been notified. Please try again shortly."
            this.error = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.loginDisabled = false
        });
    },
    // register: function() {
    //   this.$router.push("/register")
    // }
  },
  async created() {
    this.loadWebConfig();
  }
};
</script>

<style>
.versionFooter {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>